import { loc } from "../../../../../core/utils"
import { string } from "prop-types"
import React from "react"
import { Col, Row } from "react-bootstrap"

export default function ActivePromo({ promo }) {
  return (
    <li>
      <Row>
        <Col>
          <p>{loc("Promo code")}</p>
        </Col>
        <Col>
          <p className="text-right">{promo}</p>
        </Col>
      </Row>
    </li>
  )
}

ActivePromo.propTypes = {
  promo: string
}
